import React, { Component } from 'react'
import './input.css';

class TextInput extends Component {
    state = {
        focused: false
    };

    handleChange = (e) => {
        this.props.onChange && this.props.onChange(e);
    }
    setFocused = (e) => {
        this.setState({ focused: true });
    }
    setBlure = (e) => {
        this.setState({ focused: false });
    }
    render() {
        let { error, type, value, name, label } = this.props;
        error = error === undefined ? '' : error;
        type = type === undefined ? 'text' : type;
        value = value === undefined ? '' : value;

        return (
            <div className="MuiFormControl-root MuiTextField-root" style={{marginTop: '15px'}}>
                {label !== null && <label className={`MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated ${this.state.focused || this.props.type === "date" ? "Mui-focused MuiInputLabel-shrink" : ""} ${value !== '' ? "MuiInputLabel-shrink" : ""} ${error !== '' && this.state.focused ? 'Mui-error' : ''}`} htmlFor={name}>{label}</label>}
                <div className={`MuiInputBase-root MuiInput-root MuiInput-underline MuiInputBase-formControl MuiInput-formControl ${this.state.focused ? "Mui-focused" : ""} ${error !== '' ? 'Mui-error' : ''}`}>
                    <input type={type} name={name} value={value} className="MuiInputBase-input MuiInput-input w-100" onFocus={(e) => { this.setFocused(e) }} onBlur={(e) => { this.setBlure(e) }} onChange={(e) => this.handleChange(e)} {...this.props} />
                </div>
                {error !== '' && <p className="MuiFormHelperText-root Mui-error MuiFormHelperText-filled">{error}</p>}
            </div>
        );
    }
}

export default TextInput;